import PropTypes from "prop-types";
import buildUrl from "@utils/buildUrl";
import { BASE_URL, TICKET_FORM_ID } from "@constants/pois/zendeskMap";

export function SuggestAnEdit({ customFields = null, className = "" }) {
  const query = {
    ticket_form_id: TICKET_FORM_ID,
    custom_fields: JSON.stringify(customFields),
  };

  const helperUrl = buildUrl(BASE_URL, { query });
  return (
    <div data-testid="suggest-an-edit" className={className}>
      <a href={helperUrl} target="_blank" rel="nofollow noopener noreferrer">
        <em>Suggest an edit to this attraction</em>
      </a>
    </div>
  );
}

SuggestAnEdit.propTypes = {
  customFields: PropTypes.shape({}),
  className: PropTypes.string,
};
